export default __webpack_public_path__ + "static/media/zoom-meeting-camera.99089995.svg";